import { useState } from "react";
import { ArrowUpRight, User } from "lucide-react";
import { Img } from "@/components/shared/Img";
import { Reveal } from "@/components/shared/Reveal";
import { cn } from "@/lib/utils";

const Person = ({ p, i, solo }) => {
  const [open, setOpen] = useState(false);
  const long = (p.bio || "").length > 220;
  return (
    <li className={cn("group flex min-w-0 gap-5", solo ? "sm:gap-8" : "")} data-testid={`event-person-${i}`}>
      <div className={cn("relative shrink-0 overflow-hidden rounded-[18px] bg-secondary", solo ? "h-28 w-28 sm:h-40 sm:w-40" : "h-20 w-20 sm:h-24 sm:w-24")}>
        {p.image ? <Img src={p.image} alt={p.name} width={480} widths={[240, 480]} sizes="160px" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]" /> : <span className="flex h-full w-full items-center justify-center text-muted-foreground"><User className="h-7 w-7" strokeWidth={1.5} /></span>}
      </div>
      <div className="min-w-0 flex-1">
        <h3 className={cn("font-display font-semibold tracking-[-0.015em] text-balance", solo ? "text-[22px] sm:text-[26px]" : "text-[18px] sm:text-[19px]")} data-testid={`event-person-${i}-name`}>{p.name}</h3>
        {p.role && <p className="t-mono mt-1 text-sol" data-testid={`event-person-${i}-role`}>{p.role}</p>}
        {p.bio && (
          <p className={cn("mt-3 text-[15px] leading-relaxed text-foreground/75 text-pretty", solo && "sm:text-[16.5px]", long && !open && "line-clamp-4")} data-testid={`event-person-${i}-bio`}>{p.bio}</p>
        )}
        <div className="mt-3 flex flex-wrap gap-x-5 gap-y-1">
          {long && <button type="button" onClick={() => setOpen((v) => !v)} className="u-link text-[14px] font-medium" data-testid={`event-person-${i}-more`}>{open ? "Vis mindre" : "Les meir"}</button>}
          {p.url && <a href={p.url} target="_blank" rel="noopener noreferrer" className="u-link inline-flex items-center gap-1 text-[14px] font-medium" data-testid={`event-person-${i}-link`}>{p.url.replace(/^https?:\/\/(www\.)?/, "").split("/")[0]} <ArrowUpRight className="h-3.5 w-3.5" /></a>}
        </div>
      </div>
    </li>
  );
};

/** Who is on stage – speakers, artists, hosts. One person gets room to breathe; several become a calm two-column list. */
export const EventPeople = ({ people = [] }) => {
  if (!people.length) return null;
  const solo = people.length === 1;
  return (
    <Reveal as="section" id="medverkande" className="mt-14 scroll-mt-28 border-t border-border pt-10" testId="event-people">
      <p className="t-mono text-muted-foreground">{solo ? "Medverkande" : `Medverkande · ${people.length}`}</p>
      <ul className={cn("mt-6 grid gap-x-10 gap-y-9", !solo && people.length > 2 && "md:grid-cols-2")}>
        {people.map((p, i) => <Person key={`${p.name}-${i}`} p={p} i={i} solo={solo} />)}
      </ul>
    </Reveal>
  );
};
